import { Application } from "@hotwired/stimulus"
import { appsignal } from "appsignal";
import { installErrorHandler } from "@appsignal/stimulus";

const application = Application.start()

application.handleError = (error, message, detail) => {
  if (process.env.NODE_ENV != 'production' && typeof console !== 'undefined' && console.warn) {
    console.warn(message, detail);
  }
}

//* Set up error handler for AppSignal
installErrorHandler(appsignal, application);

//* Configure Stimulus development experience
application.debug    = false
window.Stimulus      = application

export { application }
